import { observer } from 'mobx-react-lite';
import React from 'react';
import { useParams } from 'react-router-dom';
import homeStore from '../../../../stores/homeStore';
import DatePickerRangeComponet from '../../../atoms/DatePickerRangeComponet';
import InputComponent from '../../../atoms/InputComponet';
import SelectComponent from '../../../atoms/SelectComponent';
import SwitchComponent from '../../../atoms/SwitchComponent';
import ContentBox from '../../../molecules/ContentBox';
import CustomerAddHome from '../CustomerAddHome';

export const modelOptions = [
    { value: 'customer', label: 'Cliente' },
    { value: 'default', label: 'Padrão' },
];

const GeneralInfomation: React.FC = observer(() => {
    const { homeProps } = homeStore;
    const { uuid } = useParams<{ uuid: string }>();

    const selectedModel = (item: any) => {
        homeStore.updateModel(item?.value);
    }

    return (
        <div>
            <ContentBox className="mb-4 p-6" borderCustom='rounded-b-lg' title="Informações Gerais" description='Tela para cadastro de home' actions={
                <>
                    <SwitchComponent name="active" checkedChildren="Ativo" unCheckedChildren="Inativo" />
                </>
            }>
                <div className="w-full flex flex-col gap-2">
                    <div className="flex gap-4">
                        <InputComponent label="Nome" name="name" id="name" />
                    </div>

                    <div className="flex gap-4">
                        <SelectComponent disabled={uuid ? true : false} onChange={(value, option) => selectedModel(option)} label="Tipo" name="model" options={modelOptions} />
                    </div>

                    <div className="flex gap-4">
                        <DatePickerRangeComponet label="Data Inicial e Final" name="date" />
                    </div>
                </div>
            </ContentBox>

            {homeProps?.model === 'customer' &&
                <CustomerAddHome />
            }
        </div>
    );
});

export default GeneralInfomation;